export const CREATE_ADMIN_NOTIFICATION_SETTINGS = "CREATE_ADMIN_NOTIFICATION_SETTINGS";   
export const RETRIEVE_ADMIN_NOTIFICATION_SETTINGS = "RETRIEVE_ADMIN_NOTIFICATION_SETTINGS";
export const RETRIEVESINGLE_ADMIN_NOTIFICATION_SETTINGS = "RETRIEVESINGLE_ADMIN_NOTIFICATION_SETTINGS";
export const UPDATE_ADMIN_NOTIFICATION_SETTINGS = "UPDATE_ADMIN_NOTIFICATION_SETTINGS";   
export const DELETE_ADMIN_NOTIFICATION_SETTINGS = "DELETE_ADMIN_NOTIFICATION_SETTINGS";   
